import type { Key } from "react";
import type React from "react";
import type { ColumnsType } from "antd/es/table/interface";

import { MetadataDashboardTemplate } from "./MetadataDashboardTemplate";
import type { ExtraTab } from "./types";
import type { FilterConditionValue } from "@/components/UI/TableToolbar/Filtering/filterTypes";
import PageHeader from "@/components/UI/PageHeader";

type PageTemplateProps = {
  title: string;
  tooltipText: string;
  type: string;
  constants: {
    wikiLink: string;
    idLink: string | undefined | ((subjectId: string) => string);
  };
  subjectId?: string;
  extraTabs?: ExtraTab[];
  extraColumns?: ColumnsType<Record<string, unknown>>;
  selectionIdentifierColumn?: string;
  /** Fixed filters merged into every table request (e.g. exclude a modality). */
  presetFilters?: Record<string, FilterConditionValue>;
  rowKey?: string | ((record: Record<string, unknown>) => Key);
  onRow?: (
    record: Record<string, unknown>,
  ) => React.HTMLAttributes<HTMLElement>;
};

export const PageTemplate = ({
  title,
  tooltipText,
  type,
  constants,
  subjectId,
  extraTabs = [],
  extraColumns = [],
  selectionIdentifierColumn = "subject",
  presetFilters,
  rowKey,
  onRow,
}: PageTemplateProps) => {
  if (subjectId) {
    return (
      <MetadataDashboardTemplate
        type={type}
        constants={constants}
        subjectId={subjectId}
        extraTabs={extraTabs}
        extraColumns={extraColumns}
        selectionIdentifierColumn={selectionIdentifierColumn}
        presetFilters={presetFilters}
        rowKey={rowKey}
        onRow={onRow}
      />
    );
  }

  return (
    <div className="w-full p-4">
      <div className="flex justify-between mb-4 relative z-20">
        <div className="flex gap-2">
          <PageHeader title={title} tooltipText={tooltipText} />
        </div>
      </div>
      <MetadataDashboardTemplate
        type={type}
        constants={constants}
        subjectId={undefined}
        extraTabs={extraTabs}
        extraColumns={extraColumns}
        selectionIdentifierColumn={selectionIdentifierColumn}
        presetFilters={presetFilters}
        rowKey={rowKey}
        onRow={onRow}
      />
    </div>
  );
};
